module.exports = __webpack_public_path__ + "img/andreea-thank-you.f825416c.png";